
import { Component, Prop, Vue } from 'vue-property-decorator'
import IconInShape from '~/components/common/icon/IconInShape.vue'

@Component({
  name: 'HeaderRoundedCtrl',
  components: {
    IconInShape
  }
})
export default class HeaderRoundedCtrl extends Vue {
  @Prop({ type: String, default: '38px' }) shapeSize!: string
  @Prop({ type: String, default: '18px' }) iconSize!: string
  @Prop({ type: String, required: true }) iconName!: string
  @Prop({ type: String }) iconColor!: string
  @Prop({ type: String }) iconFill!: string
  @Prop({ type: String, default: 'transparent' }) iconStroke!: string
  @Prop({ type: Boolean, default: false }) isActive!: boolean
  @Prop({ type: [Number, Boolean], default: 0 }) isHasNew!: 0 | 1 | boolean
  @Prop({ type: Object, default: () => ({ regular: 'bg-gray-4', hover: 'hover:bg-oth-1', active: 'bg-oth-3' }) }) classes!: string
  @Prop({ type: String, default: '#' }) href!: string
}
